var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"mr-5",attrs:{"label-for":_vm.inputId,"label":_vm.label}},[_c('b-form-input',{attrs:{"id":_vm.inputId,"autocomplete":"off"},on:{"input":_vm.emitChange},model:{value:(_vm.dataInputComponentValue),callback:function ($$v) {_vm.dataInputComponentValue=$$v},expression:"dataInputComponentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }